var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab_view"},[_c('div',{staticClass:"tab_view__tabs",class:{
			"tab_view__tabs--small_tabs": _vm.smallTabs,
			"tab_view__tabs--transparent": _vm.transparent
		}},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:"tab-" + index,staticClass:"tab_view__tab",class:{
				"tab_view__tab--selected": _vm.tabIndex === index,
				"tab_view__tab--selected_small_tabs": _vm.tabIndex === index && _vm.smallTabs,
				"tab_view__tab--selected_transparent": _vm.tabIndex === index && _vm.transparent,
				"tab_view__tab--small_tabs": _vm.smallTabs,
				"tab_view__tab--transparent": _vm.transparent
			},on:{"click":function($event){return _vm.changeTab(index)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0),_c('div',{staticClass:"tab_view__content",class:{
			"tab_view__content--padding": _vm.padding,
			"tab_view__content--transparent": _vm.transparent
		}},[_vm._t(_vm.currentTab)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }